// extracted by mini-css-extract-plugin
module.exports = {"edwpcny":"edwpcny"};